"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var req_1 = __importDefault(require("./req"));
var reducer = function (state, action) {
    var findByFilename = function (filename) {
        return state.find(function (downloadFile) { return downloadFile.filename === filename; });
    };
    var file = findByFilename(action.payload.filename);
    switch (action.type) {
        case 'REGISTER':
            if (!file) {
                state.push({
                    filename: action.payload.filename,
                    downloadUrl: action.payload.downloadUrl,
                    status: 'registered',
                });
            }
            else {
                file.status = 'registered';
                file.downloadUrl = action.payload.downloadUrl;
                state.splice(state.indexOf(file), 1, file);
            }
            return __spreadArrays(state);
        case 'DOWNLOAD':
            if (file) {
                file.status = 'downloading';
                state.splice(state.indexOf(file), 1, file);
                return __spreadArrays(state);
            }
            break;
        case 'FINISH':
            if (file) {
                file.status = 'done';
                state.splice(state.indexOf(file), 1, file);
                return __spreadArrays(state);
            }
            break;
        default:
            break;
    }
    return state;
};
function usePresignedDownload() {
    var _this = this;
    var _a = react_1.useReducer(reducer, []), files = _a[0], dispatch = _a[1];
    var getDownloadLink = function (filename) { return __awaiter(_this, void 0, void 0, function () {
        var link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, req_1.default.get('/storage/download-link', {
                        params: {
                            fileName: filename,
                            fileCategory: 'documentos',
                        },
                    })];
                case 1:
                    link = (_a.sent()).link;
                    dispatch({
                        type: 'REGISTER',
                        payload: {
                            filename: filename,
                            downloadUrl: link,
                        },
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var registerFile = function (filename) {
        getDownloadLink(filename);
    };
    var downloadFile = function (file) { return __awaiter(_this, void 0, void 0, function () {
        var blob, fileURL, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'DOWNLOAD',
                        payload: {
                            filename: file.filename,
                        },
                    });
                    return [4 /*yield*/, req_1.default.get(file.downloadUrl, { responseType: 'blob' })];
                case 1:
                    blob = _a.sent();
                    fileURL = URL.createObjectURL(blob);
                    link = document.createElement('a');
                    link.href = fileURL;
                    link.download = file.filename;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    link.click();
                    dispatch({
                        type: 'FINISH',
                        payload: {
                            filename: file.filename,
                        },
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        files.forEach(function (file) {
            if (file.status === 'registered') {
                downloadFile(file);
            }
        });
    }, [files]);
    return {
        registerFile: registerFile,
        files: files,
    };
}
exports.default = usePresignedDownload;
